/**
 * Transforms EditorProps to an FeatureFlags object,
 * which is used by both current and archv3 editors.
 */
export function createFeatureFlagsFromProps(props) {
    return {
        newInsertionBehaviour: props.allowNewInsertionBehaviour,
        interactiveExpand: typeof props.allowExpand === 'boolean'
            ? props.allowExpand
            : Boolean(props.allowExpand &&
                props.allowExpand.allowInteractiveExpand !== false),
        placeholderBracketHint: !!props.placeholderBracketHint,
        placeholderHints: Array.isArray(props.placeholderHints) &&
            props.placeholderHints.length > 0,
        moreTextColors: typeof props.allowTextColor === 'boolean'
            ? false
            : Boolean(props.allowTextColor &&
                props.allowTextColor.EXPERIMENTAL_allowMoreTextColors === true),
        extensionConfigPanel: typeof props.allowExtension === 'boolean'
            ? false
            : !!(props.allowExtension && props.allowExtension.allowNewConfigPanel),
    };
}
/**
 * Transforms FeatureFlags to a type safe string array of the enabled feature flags.
 *
 * Useful for analytics and analysis purposes.
 */
export function getEnabledFeatureFlagKeys(featureFlags) {
    return Object.keys(featureFlags).filter(function (key) { return featureFlags[key] === true; });
}
//# sourceMappingURL=feature-flags-from-props.js.map